/**
 * Searchnav actions.
 * @module actions/searchnav/searchnav
 */

import { GET_SEARCHNAV } from '@fhnw/constants/ActionTypes';

/**
 * Get searchnav.
 * @function getSearchnav
 * @param {string} url Content url.
 * @returns {Object} Get searchnav action.
 */
export function getSearchnav(url: string) {
  return {
    type: GET_SEARCHNAV,
    request: {
      op: 'get',
      path: `${url}/@searchnav`,
    },
  };
}
